import React from 'react';
import Iconify from '../../../Iconify';
import Skeleton from '@mui/material/Skeleton';
import { Box, Typography } from '@mui/material';
import { FormatDate } from '../../../../utils/formatDate';
import ContractRenewStatus from '../../../contracts/contractRenewStatus';

const MachineContractListViewData = ({ contract, handleContractClick, columnWidth }) => {

    if (!contract) {
        return (
            <Box className='table_row'>
                <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.title, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.company }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.contract_number }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.date }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.auto_renew }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.machines }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
            </Box>
        );
    }

    const uniqueMachineIds = new Set();
    contract.contract_date.forEach((entry) => {
        entry.contract_machine.forEach((machine) => {
            uniqueMachineIds.add(machine.machine.id);
        });
    });                    

    return (
        <Box className='table_row' onClick={() => handleContractClick(contract.id)}>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.title, maxWidth: columnWidth.title, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
                <Typography className='tableBodyTypography'>{contract.title}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.company, maxWidth: columnWidth.company }}>
                <Typography className='tableBodyTypography'>{contract.company.name}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.contract_number, maxWidth: columnWidth.contract_number }}>
                <Typography className='tableBodyTypography'>{contract.contract_number ? contract.contract_number : 'N/A'}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.date, maxWidth: columnWidth.date }}>
                <Typography className='tableBodyTypography'>{FormatDate(contract.firstPeriodStartDate)} - {FormatDate(contract.lastPeriodEndDate)}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.auto_renew, maxWidth: columnWidth.auto_renew }}>
                <ContractRenewStatus status={contract?.auto_renew} />
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.machines, maxWidth: columnWidth.machines }}>
                <Typography className='tableBodyTypography'>{uniqueMachineIds.size} machines</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px', maxWidth: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
        </Box>
    );
};

export default MachineContractListViewData;